import { ClientIntegration, DataFromUrl, handleOtherResponseCode, SUCCESS_REPONSE_CODE, toastr,
         UNAUTHORIZED_REPONSE_CODE, useTranslation, REDIRECT, CustomToastrAction  } from '@/imports-files/pages/admins/dashboard/clients/integration';


export function createIntegrationData(index, integrations, logo, type, limit, status, client_integration_id, integration_id, isDisabled, isChecked)
{
  return { index, integrations, logo, type, limit, status, client_integration_id, integration_id, isDisabled, isChecked};
}

// export async function requestIntegrations(user_type, router) {
//   const body = {user_type: user_type};
//   const result = await new ClientIntegration().getIntegrations(body);
//   const status_code = result.status || result.response.status;

//   switch (status_code) {
//     case SUCCESS_REPONSE_CODE:
//       const response = result.data;
//       if (response.success) {
//         return response.data;
//       }
//       break;
//     case UNAUTHORIZED_REPONSE_CODE:
//       toastr.warning(result.response.data.error);
//       break;
//     default:
//       handleOtherResponseCode(status_code, router);
//   }
// }

export async function submitIntegrationsForm(values, router, setButtonPopup, current_step) {

  let client_integrations_attributes              =   values.client.client_integrations_attributes
  // client_integrations_attributes                  =   client_integrations_attributes.filter(function(x) {
  //                                                       return x.is_enabled;
  //                                                     });
  values.client.client_integrations_attributes    =   client_integrations_attributes.map((x) => { delete x["is_enabled"]; return x; });
  const client_id                                 =   new DataFromUrl().getClientId();
  const result                                    =   await new ClientIntegration().addIntegrations(values, client_id );
  const status_code                               =   result.status || result.response.status;
  const customToastrAction                        =   new CustomToastrAction(); 

  switch (status_code) {
    case SUCCESS_REPONSE_CODE:
      const response = result.data;
      if (response.success) {
        if(response.step == current_step){
          // toastr.success('Integrations updated successfully.')
          customToastrAction.setNormalToastr('Integrations updated successfully.', 'success');
          setTimeout(() => router.push(REDIRECT.admins.dashboard.clients.client), 50)
        } 
        else{
          setButtonPopup(true);
        }
        return response;
      }
      break;
    case UNAUTHORIZED_REPONSE_CODE:
      // toastr.warning(result.response.data.error);
      customToastrAction.setNormalToastr(result.response.data.error, 'warning');
      break;
    default:
      handleOtherResponseCode(status_code, router);
  }
}

export async function getIntegrationData(setApiError, router) {
  const client_id = new DataFromUrl().getClientId();
  const body = { user_type: "client", id: client_id , ...router.query};
  const integration_data = await new ClientIntegration().getIntegrations(
    body,
    client_id
  );
  setApiError(integration_data.request);
  const integrations = integration_data?.data?.client_integrations || [];
  const step = integration_data?.data?.step;
  const filterOptions = integration_data?.data?.job_boards_listing;
  const data = {
    props: {
      integrations,
      step,
      filterOptions,
    },
  };
  return data;
}